import { createFileRoute, redirect } from '@tanstack/react-router'
import { RETURN_TO_KEY } from '../lib/constants'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // After OIDC callback redirects to /, check if we have a saved return URL
    const returnTo = sessionStorage.getItem(RETURN_TO_KEY)
    if (returnTo) {
      sessionStorage.removeItem(RETURN_TO_KEY)
      throw redirect({ to: returnTo })
    }
    throw redirect({ to: '/dashboard' })
  },
})
